import { useQuery } from '@tanstack/react-query'

import queries from '@/api/queries'
import statusResources from '@/api/status'

const useInvoices = () =>
  useQuery(queries.status(), statusResources.get, {
    staleTime: Infinity,
  }).data?.invoices

export default useInvoices
